import { useEffect } from "react";
import { useScript } from "react-recipes";

import { jjLogger, newRelic } from "utils/logUtils";
import useSettings from "hooks/useSettings";

const useRecaptcha = () => {
  const {
    settings: {
      recaptcha: {
        enabled: recaptchaEnabled,
        subscription_enabled: recaptchaSubscriptionEnabled,
        login_enabled: recaptchaLoginEnabled,
        key: recaptchaKey,
      },
    },
  } = useSettings();

  const [recaptchaLoaded, recaptchaLoadError] = useScript(
    `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`,
  );

  useEffect(() => {
    if (recaptchaEnabled && recaptchaLoaded && recaptchaLoadError) {
      const error = "useRecaptcha.js: Error loading recaptcha script";

      newRelic(error);
      jjLogger.log(error);
    }
  }, [recaptchaLoaded, recaptchaLoadError]);

  const actionEnabled = (actionName) => {
    switch (actionName) {
      case "subscription":
        return recaptchaEnabled && recaptchaSubscriptionEnabled;
      case "login":
        return recaptchaEnabled && recaptchaLoginEnabled;
      default:
        return false;
    }
  };

  const recaptcha = (settings) =>
    new Promise((resolve) => {
      if (!actionEnabled(settings.actionName)) return resolve();

      return window.grecaptcha.ready(() => {
        window.grecaptcha.execute(recaptchaKey, { action: settings.actionName }).then((recaptchaToken) => {
          resolve(recaptchaToken);
        });
      });
    });

  return {
    recaptcha,
    actionEnabled,
  };
};

export default useRecaptcha;
